/**
 * Whether an AG Grid row drop lands BELOW the row it was dropped on.
 *
 * AG Grid's `vDirection` only reports the LAST mouse-move tick, and is `null`
 * whenever that tick was horizontal or the pointer was still — which is the
 * usual state at the instant you release. Deriving `after` from it therefore
 * read as `false` on nearly every drop, so each row landed one slot too high:
 * dropping onto a row resolved as "before it", so the move came out unchanged
 * and no save fired even though the managed drag had visually moved the row.
 *
 * Read geometry instead, exactly as the tree rail's `resolveDropSlot` does:
 * below the over-row's midpoint means "after it". AG Grid's `rowDragEnd` event
 * hands us `y` (the mouse pixel, 0 = top of first row) alongside the over
 * node's `rowTop` and `rowHeight` in that same space — the docs point here.
 */
export interface RowDragGeometry {
  /** The event's `y`: mouse vertical pixel, 0 = top of the first row. */
  pointerY: number
  /** The over row's top edge, same coordinate space as `pointerY`. */
  rowTop: number
  /** The over row's height. */
  rowHeight: number
}

export const resolveRowDragAfter = ({
  pointerY,
  rowTop,
  rowHeight,
}: RowDragGeometry): boolean => pointerY >= rowTop + rowHeight / 2
